import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { AiMedicalDocumentItem, AppointmentType } from '@lib/medical-documents';
import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { Visit } from '@lib/core/models/visit.interface';

import { InfoBadgeComponent } from '@lib/shared-ui/commons/info-badge/info-badge.component';
import { StatusComponent } from '@lib/shared-ui/commons/status/status.component';

@Component({
  standalone: true,
  selector: 'md-document-details',
  imports: [TranslatePipe, MatIcon, StatusComponent, InfoBadgeComponent],
  templateUrl: './document-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentDetailsComponent {
  readonly userAppointments = input.required<Visit[]>();
  readonly currentAiDocument = input<AiMedicalDocumentItem | null>(null);
  readonly canEdit = input<boolean>(true);
  readonly detailsClosed = output<boolean>();
  readonly detailsOpened = output<boolean>();
  readonly editModeOpened = output<boolean>();

  protected readonly formatDate = formatDate;

  protected readonly linkedAppointment = computed<Visit>(() => this.userAppointments()?.find(item => item.id === this.currentAiDocument().appointmentId));

  protected readonly formattedFileName = computed<string>(() => this.currentAiDocument().fileName.replace(/-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi, ''));

  protected get isDocumentBoundToUser(): boolean {
    return this.currentAiDocument()?.userId != null && this.currentAiDocument()?.userId !== '00000000-0000-0000-0000-000000000000';
  }

  protected getDocumentType(type: string): string {
    return AppointmentType[type as keyof typeof AppointmentType] || type;
  }

  protected hideDetails() {
    this.detailsClosed.emit(true);
  }

  protected openEditMode() {
    this.editModeOpened.emit(true);
  }
}
